import { render, staticRenderFns } from "./CommonTopic.vue?vue&type=template&id=127bbf62&"
import script from "./CommonTopic.vue?vue&type=script&lang=ts&"
export * from "./CommonTopic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports